import { isDomainZone } from '@common/utils/lang';
import SuperExactScoreBoard from '@features/super-exact-score/components/board/SuperExactScoreBoard';
import SuperExactScoreEvent from '@features/super-exact-score/components/events/SuperExactScoreEvent';
import Box from '@mui/material/Box';
import cx from 'classnames';
import getUnixTime from 'date-fns/getUnixTime';
import React, { FC, useMemo, useState } from 'react';
import { ISuperExactScoreResponse } from '../api/superExactScore.type';

const SuperExactScoreResults: FC<ISuperExactScoreResponse> = ({ exactScore, exactScoreBets }) => {
    const events = exactScore.events;
    const now = getUnixTime(new Date());

    const initialIndex = useMemo(() => {
      const finishedEvents = events.filter(event => event.onlineTime < now);
      if (finishedEvents.length > 0) {
        const lastFinishedOnlineTime = Math.max(...finishedEvents.map(e => e.onlineTime));
        const lastFinishedIndex = events.findIndex(e => e.onlineTime === lastFinishedOnlineTime);
        return lastFinishedIndex;
      }
      const nextIndex = events.findIndex(event => event.onlineTime > now);
      return nextIndex !== -1 ? nextIndex : 0;
  }, [events, now]);

    const [selectedIndex, setSelectedIndex] = useState(initialIndex);

    const handleSelectEvent = (index: number) => () => {
      setSelectedIndex(index);
    };

    return (
     <Box className={cx('super-exact-score', {
       'boxbet': isDomainZone('boxbet')
     })}>
       <Box className="super-exact-score-flex">
         <SuperExactScoreBoard
           selectedIndex={selectedIndex}
           event={
             {...exactScore?.events[selectedIndex]}
           }
           exactScoreBets={exactScoreBets}
           exactScoreId={exactScore.id}
         />
         <Box className="super-exact-score-events" maxWidth="sm" marginX="auto">
           {exactScore.events.map((event, index) => (
             <SuperExactScoreEvent
               bet={exactScoreBets}
               {...event}
               key={event.id}
               onClick={handleSelectEvent(index)}
               selected={selectedIndex === index}
             />
           ))}
         </Box>
       </Box>
     </Box>
    )
};

export default SuperExactScoreResults;
